class PageDataParsingException extends Error {
  constructor(message) {
    super(message);
    this.name = 'PageDataParsingException';
    this.errorStatusCode = 500;
  }
}

export default PageDataParsingException;
